// @ts-ignore
import GLightbox from 'glightbox/dist/js/glightbox';
import {Media2Click} from "../Media2Click";

export class Lightbox {
  private selector: string;
  private lightboxes: NodeListOf<Element>;
  private items: any[];

  constructor() {
    this.selector = 'data-lightbox';
    this.lightboxes = document.querySelectorAll('[' + this.selector + ']');
    this.items = [];
    this.init();
  }

  init() {
    const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
        <div class="gloader visible"></div>
        <div class="goverlay"></div>
        <div class="gcontainer">
        <div id="glightbox-slider" class="gslider"></div>
        <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example"><i class="im im-angle-right-circle"></i></button>
        <button class="gprev gbtn" tabindex="1" aria-label="Previous"><i class="im im-angle-left-circle"></i></button>
    </div>
    </div>`;

    let customSlideHTML = `<div class="gslide">
        <div class="gslide-inner-content">
            <div class="ginner-container">
                <button class="gclose gbtn" tabindex="2" aria-label="Close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"></path></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"></path></g></g></svg></button>
                <div class="gslide-media">
                </div>
                <div class="gslide-description">
                    <div class="gdesc-inner">
                        <h4 class="gslide-title"></h4>
                        <div class="gslide-desc"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>`;

    this.lightboxes.forEach((item) => {
      let groupIdentifier = item.getAttribute(this.selector);
      if (this.items.indexOf(groupIdentifier) === -1) {
        this.items.push(groupIdentifier);
      }
    });

    this.items.forEach((item) => {
      let lightbox = GLightbox({
        lightboxHTML: customLightboxHTML,
        slideHTML: customSlideHTML,
        selector: '[' + this.selector + '="' + item + '"]',
        moreLength: 0
      });

      lightbox.on('slide_after_load', (data) => {
        const {slideIndex, slideNode, slideConfig, player, trigger} = data;

        let closeButton = slideNode.querySelector('.gclose');
        if (closeButton !== null) {
          closeButton.addEventListener('click', function () {
            lightbox.close();
          });
        }

        let media2clickPlaceholder = slideNode.querySelector('.media2click-placeholder');
        if (media2clickPlaceholder !== null) {
          new Media2Click(slideNode);
        }
      });
    });
  }
}

new Lightbox();
